import React, { useState } from "react";
import PropTypes from "prop-types";
import { FiX, FiTrash2 } from "react-icons/fi";

import { CouponRulesModal } from "page/OrderResumePag/_components/CouponRulesModal";
import {
  CouponTitle,
  CouponRow,
  CouponInputWrap,
  CouponApplyButton,
  CouponErrorText,
  CouponSuccessBox,
} from "../styles";

export default function CouponField({
  coupon,
  setCoupon,
  isCouponApplied,
  couponInfo,
  couponError,
  loadingCoupon,
  applyCoupon,
  removeCoupon,
}) {
  const [rulesOpen, setRulesOpen] = useState(false);

  const code = couponInfo?.code || couponInfo?.name || coupon;
  const category = couponInfo?.category || couponInfo?.type;
  const rules = couponInfo?.rules;

  function handleKeyDown(e) {
    if (e.key === "Enter") {
      e.preventDefault();
      applyCoupon();
    }
  }

  return (
    <div>
      <CouponTitle>Cupom de desconto / Gift Card</CouponTitle>

      {isCouponApplied ? (
        <CouponSuccessBox>
          <div className="coupon-success-head">
            <span className="coupon-code">{code}</span>
            <button
              type="button"
              className="coupon-remove"
              aria-label="Remover cupom"
              disabled={loadingCoupon}
              onClick={removeCoupon}
            >
              <FiTrash2 />
            </button>
          </div>
          <p className="coupon-category">
            {category ? `Cupom de ${category} aplicado` : "Cupom aplicado"}
          </p>
          {rules && (
            <button
              type="button"
              className="coupon-rules-link"
              onClick={() => setRulesOpen(true)}
            >
              Ver regra de uso
            </button>
          )}
        </CouponSuccessBox>
      ) : (
        <>
          <CouponRow>
            <CouponInputWrap>
              <input
                type="text"
                value={coupon}
                placeholder="Digitar código"
                onChange={(e) => setCoupon(e.target.value)}
                onKeyDown={handleKeyDown}
              />
              {coupon?.length > 0 && (
                <button
                  type="button"
                  className="clear-btn"
                  aria-label="Limpar"
                  onClick={() => setCoupon("")}
                >
                  <FiX />
                </button>
              )}
            </CouponInputWrap>
            <CouponApplyButton
              type="button"
              disabled={!coupon?.trim() || loadingCoupon}
              onClick={applyCoupon}
            >
              {loadingCoupon ? "..." : "Aplicar"}
            </CouponApplyButton>
          </CouponRow>
          {couponError && <CouponErrorText>{couponError}</CouponErrorText>}
        </>
      )}

      <CouponRulesModal
        open={rulesOpen}
        setOpen={setRulesOpen}
        couponRules={rules}
      />
    </div>
  );
}

CouponField.propTypes = {
  coupon: PropTypes.string,
  setCoupon: PropTypes.func,
  isCouponApplied: PropTypes.bool,
  couponInfo: PropTypes.object,
  couponError: PropTypes.string,
  loadingCoupon: PropTypes.bool,
  applyCoupon: PropTypes.func,
  removeCoupon: PropTypes.func,
};
